const styles = {
  imageContainer: {
    backgroundImage: 'linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0)), url("https://assets-liber.s3.amazonaws.com/images/paqueteria-background.jpg")', 
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    padding: '20px',
    display: 'flex',
    backgroundRepeat: 'no-repeat',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageTitle: {
    fontSize: {
      xs: '18px',
      sm: '18px',
      md: '28px',
      lg: '34px',
      xl: '40px'
    },
    color: '#FFF', 
    marginBottom: '0px', 
    fontWeight: '600'
  },
  imageSubtitle: {
    fontSize: {
      xs: '18px',
      sm: '18px',
      md: '20px',
      lg: '22px',
      xl: '28px'
    },
    color: '#FFF',
  }
};

export default styles;